require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-leaders-today-icons-tomorrow.json") })
        }
      }, "path---insights-leaders-today-icons-tomorrow");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-leaders-today-icons-tomorrow!./.cache/json/insights-leaders-today-icons-tomorrow.json
// module id = 1136
// module chunks = 231608221292675